module.exports = __webpack_public_path__ + "img/img1.6ad411eb.jpg";